import GoogleMap, { SelectedPlace } from 'components/GoogleMap/GoogleMap';
import cx from 'classnames';
import {
  useAppDispatch,
  useAppSelector,
} from 'components/hooks/redux-selectors';
import OrdersProgressCard from 'components/OrdersComponents/OrdersProgressCard/OrdersProgressCard';
import Toggle from 'components/OrdersComponents/Toggle';
import React, { useEffect, useState } from 'react';
import { GoChevronDown, GoChevronUp } from 'react-icons/go';
import { singleOrderDetails, allOrderDetails } from 'actions';
import Spinner from 'components/common/Spinner/Spinner';
import SingleOrderDetails from 'components/SingleOrderDetails/SingleOrderDetails';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import InvoiceIframe from '../InvoiceIframeModal/InvoiceIframe';
import InnerWidth from '../InnerWidth';
import LessOrderDetails from '../LessOrderDetails/LessOrderDetails';
import { TbRefresh } from 'react-icons/tb';
import Button from 'components/common/Button/Button';

const OrderProgress = () => {
  const [refreshLoading, setRefreshLoading] = useState(false);
  const allOrders = useAppSelector((state) => state.orderDetails.allOrders);
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const { data: orderDetails, isLoading } = useAppSelector(
    (state) => state.orderDetails.singleOrder
  );
  const router = useRouter();
  const dispatch = useAppDispatch();

  const firstOrder = allOrders.data?.pending?.[0];

  const stage = firstOrder?.stages.find(
    (stage) => stage.StatusId === firstOrder.stageStatus
  );

  useEffect(() => {
    if (isAuthenticated) {
      if (firstOrder) {
        dispatch(singleOrderDetails(firstOrder.id));
      }
    } else {
      toast.error('You are not logged in.', {
        autoClose: 3000,
        onClose: () => router.push('/login'),
      });
    }
  }, [isAuthenticated, dispatch, firstOrder, router]);

  const showOrderDetails = isLoading ? (
    <Spinner />
  ) : (
    <div>
      <SingleOrderDetails orderDetails={orderDetails} />
    </div>
  );

  const currentStageIndex = firstOrder?.stages.findIndex(
    (stage) => stage.StatusId === firstOrder.stageStatus
  );

  const onRefreshClick = async () => {
    setRefreshLoading(true);
    await dispatch(allOrderDetails());
    setRefreshLoading(false);
  };

  if (!firstOrder) {
    return <div>No orders available</div>;
  }

 const pathCoordinates = firstOrder.pois.map((poi) => ({
    lat: parseFloat(poi.Lat),
    lng: parseFloat(poi.Lng),
  }));
  return (
    <div className="relative w-full h-full">
      <GoogleMap
        zoom={18}
        center={{
          lat: firstOrder?.centeredPoi?.Lat ?? '0',
          lng: firstOrder?.centeredPoi?.Lng ?? '0'
        }}
        className="hidden md:block h-full w-full"
        pathCoordinates={pathCoordinates}
      >
        {firstOrder.pois.map((poi) => (
          <SelectedPlace
            key={poi.id}
            lat={poi.Lat}
            lng={poi.Lng}
            text={
              <img src={poi.Icon} alt="POI Icon" className="text-2xl leading-none w-16 h-16" />
            }
          />
        ))}
      </GoogleMap>
      <InnerWidth>
        {(innerWidth) => (
          <Toggle initial={innerWidth < 768}>
            {({ isExpanded, setIsExpanded }) => (
              <OrdersProgressCard
                className={cx({
                  'w-full h-full md:w-[80%] md:h-auto ': true,
                  'md:!h-[90%] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2':
                    isExpanded
                })}
                buttonNode={
                  <div className="hidden md:flex rounded-md text-white items-center justify-center p-2 sticky bottom-0 font-bold text-2xl mt-auto ">
                    <div className="ml-2 leading-none text-2xl">
                      {isExpanded ? (
                        <div
                          onClick={() => setIsExpanded(!isExpanded)}
                          className="cursor-pointer inline-flex items-center bg-black rounded-3xl py-4 px-8 opacity-80"
                        >
                          View less
                          <GoChevronUp className="ml-2" />
                        </div>
                      ) : (
                        <div
                          onClick={() => setIsExpanded(!isExpanded)}
                          className="cursor-pointer inline-flex items-center mt-4 bg-black rounded-3xl py-4 px-8 opacity-80"
                        >
                          View all details
                          <GoChevronDown className="ml-2" />
                        </div>
                      )}
                    </div>
                  </div>
                }
              >
                <LessOrderDetails
                  currentStageIndex={currentStageIndex}
                  stage={stage}
                  order={firstOrder}
                />
                {/* <div className="flex items-center justify-between">
                  <div>
                    {refreshLoading ? (
                      <TbRefresh
                        title="Refresh the Order"
                        className="cursor-pointer text-5xl duration-200 animate-spin mt-8 w-auto rounded-[80px]"
                      />
                    ) : (
                      <Button
                        onClick={onRefreshClick}
                        className="mt-8 w-auto rounded-[80px]"
                        text="Get Status"
                      />
                    )}
                  </div>

                  {process.env.NODE_ENV === 'development' && (
                    <div className="text-red">{firstOrder.id}</div>
                  )}
                </div> */}
                <div>
                  {isExpanded && (
                    <div className="pt-4">
                      <div className="space-y-4">
                        {firstOrder.delivery_address && (
                          <div>{firstOrder.delivery_address}</div>
                        )}

                        {firstOrder.delivery_notes && (
                          <div>
                            <span className="font-bold text-orange-500">
                              Notes:
                            </span>{' '}
                            {firstOrder.delivery_notes}
                          </div>
                        )}

                        {showOrderDetails}

                        <InvoiceIframe invoiceUrl={firstOrder.invoice_url} />
                      </div>
                    </div>
                  )}
                </div>
              </OrdersProgressCard>
            )}
          </Toggle>
        )}
      </InnerWidth>
    </div>
  );
};

export default OrderProgress;
